<template>
  <vita-mobile-screen v-if="isMobile" />
  <router-view v-else />
  <vita-modal :title="errorMessage" v-if="errorMessage">
    <vita-button @click="closeErrorMessage" type="small" data-qa="app-button-error-close">Закрыть</vita-button>
  </vita-modal>
  <vita-loader v-if="loader"></vita-loader>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import VitaMobileScreen from '@/components/VitaMobileScreen.vue';
import { isMobile } from '@/utils/main';

const store = useStore()

const closeErrorMessage = () => {
  store.commit('data/closeErrorDialog', '')
}

const errorMessage = computed<string | null>(() => {
  return store.getters['data/errorModal']
})

const loader = computed<boolean>(() => {
  return store.getters['user/loader']
})
</script>

<style lang="scss">
@use 'static/style/global.scss' as *;
</style>
